import OngoingCosts from "./OngoingCosts.svg";

export default OngoingCosts;
